import { Plugin, PluginKey } from '@tiptap/pm/state';
import { getImageFilesFromFileList } from '../../utils/imageTransfer';
import { insertImages } from '../../utils/imageInsert';

const getImageDropPastePlugin = () => {
  return new Plugin({
    key: new PluginKey('imageDropPaste'),
    props: {
      handleDrop(view, event, _slice, moved) {
        // If it's a node move and there’s no file item, let ProseMirror handle it
        if (moved && event?.dataTransfer?.items) {
          const hasFileItem = Array.from(event.dataTransfer.items).some((it) => it.kind.includes('file'));
          if (!hasFileItem) return false;
        }

        const dt = event?.dataTransfer;
        if (!dt || !dt.files?.length) return false;

        const imgFiles = getImageFilesFromFileList(dt.files);
        if (!imgFiles.length) {
          // Prevent navigation when dropping non-image files
          event.preventDefault();
          return true;
        }

        event.preventDefault();
        const coords = view.posAtCoords({ left: event.clientX, top: event.clientY });
        const insertPos = coords?.pos ?? view.state.selection.from;

        return insertImages({ view, files: imgFiles, insertPos, eventMeta: 'drop' });
      },
    },
  });
};

export default getImageDropPastePlugin;
